import React, { Component } from "react";
import { Button, Input, Table } from "semantic-ui-react";
import { connect } from "react-redux";
import { parseString } from "xml2js";
import _, { isNumber } from "lodash";
import { expireSession } from "../../actions/auth";
import api from "../../api";
import settings from "../../settings";
import { loadUi } from "../../actions/search";
import { getErrorMessage } from "../messages/errorMessages";
import { removeUserCaseCharges } from "../../actions/userCaseCharges";
import {getErrorNode} from "../../utils/errorUtil";

const trimDollar = (val) => {
  if (!val) return "0.0000";
  if (val.indexOf("$") < 0) return val;
  return val.substring(1);
};

const getDollarValue = (str) => `$${parseFloat(trimDollar(str)).toFixed(2)}`;

class EditCaseDetails extends Component {
  constructor(props) {
    super(props);
    this.loadCaseCharges(props);
    this.state = {
      reports: [],
      currentCase: props.currentCase,
      customFolderCosts: [],
      combinedCosts: [],
      errorNode: undefined
    };
  }

  componentWillReceiveProps(nextProps) {
    this.loadCaseCharges(nextProps);
    if (this.isCompMounted) {
      this.setState({ currentCase: nextProps.currentCase });
    }
  }

  componentWillUnmount() {
    this.isCompMounted = false;
  }

  onChange = (e) =>
    this.setState({
      currentCase: {
        ...this.state.currentCase,
        [e.target.name]: e.target.value,
      },
    });

  isCompMounted = false;

  reportCostChanged = (e, data, id) => {
    const combinedCosts = this.state.combinedCosts;
    combinedCosts[`${id}`] = data.value;
    this.setState({ combinedCosts });
  };

  loadCaseCharges = (props) => {
    this.isCompMounted = true;
    props.onLoadStart();
    const params = {
      view: "newcase",
      sserver: settings.appName,
      userID: props.user.userid,
      sessionID: localStorage.getItem("sessionID"),
    };
    api.lp
      .getActivitiesView(params)
      .then((res) => {
        parseString(res.data, { async: false }, (err, result) => {
          if(result == null) {
              const errorNode = getErrorNode();
              this.setState({ activityNode: errorNode });
              return;
          }
          const root = Object.keys(result)[0];
          if (root === "errors") {
            if (
              _.get(result, `${root}.error[0].$.errType`) === "unauthorized"
            ) {
              localStorage.errorMessage = _.get(
                result,
                `${root}.error[0].errMsg[0]`,
                ""
              );
              const errorMessage = getErrorMessage(
                localStorage.errorMessage,
                _.get(result, `${root}.error[0].errMsg[0]`, "")
              );
              this.props.expireSession(errorMessage);
            }
          } else {
            const reports = _.get(
              result,
              "searchMenu.soap:Envelope[0].soap:Body[0].GetUserSearchListExResponse[0].GetUserSearchListExResult[0].UserItems[0].Reports[0].row"
            );
            const combinedCosts = [];
            const updatedReports = [];
            _.forEach(reports, (report) => {
              report.intReportId = parseInt(report.ReportID, 10);
              const repCost = _.get(report, "$.userCost")
                ? _.get(report, "$.userCost")
                : report.SearchResultCost[0];
              combinedCosts[`${report.intReportId}`] = isNumber(repCost)
                ? getDollarValue(report.SearchResultCost[0])
                : repCost;
              updatedReports.push(report);
            });
            const orderedReports = _.orderBy(
              updatedReports,
              ["ReportTypeDescription[0]", "intReportId"],
              ["asc", "asc"]
            );
            if (this.isCompMounted) {
              this.setState({
                reports: orderedReports,
                combinedCosts,
              });
              this.loadCaseCustomCharges(props);
            }
          }
        });
        props.onLoadComplete();
      })
      .catch((err) => console.log("load case charges error - ", err));
  };

  loadCaseCustomCharges = (props) => {
    props.onLoadStart();
    const params = {
      sserver: settings.appName,
      userID: props.user.userid,
      sessionID: localStorage.getItem("sessionID"),
      fetchAll: true,
      folderIds: [],
    };
    api.lp
      .getCaseCostDetails(params)
      .then((res) => {
        if (this.isCompMounted) {
          const combinedCosts = this.state.combinedCosts;
          const customFolderCosts = res.data.Data;
          if (
            this.state.currentCase &&
            this.state.currentCase.folderCode &&
            customFolderCosts &&
            Object.keys(customFolderCosts).length > 0
          ) {
            const customFolderCostsForCurrentCase =
              customFolderCosts[
                parseInt(this.state.currentCase.folderCode, 10)
              ];
            _.forEach(customFolderCostsForCurrentCase, (currentCaseCost) => {
              combinedCosts[currentCaseCost.reportId] = getDollarValue(
                currentCaseCost.cost
              );
            });
          }
          this.setState({ customFolderCosts, combinedCosts });
        }
        props.onLoadComplete();
      })
      .catch((err) => console.log("load case charges error - ", err));
  };

  submit = () => {
    this.props.onLoadStart();
    const currentCase = this.state.currentCase;
    let folderCode = currentCase.folderCode;
    if (parseInt(folderCode, 10) < 1) {
      folderCode = "";
    }
    const reportCosts = [];
    _.forEach(Object.keys(this.state.combinedCosts), (repId) => {
      const repInput = document.getElementById(`rep_val_${repId}`);
      reportCosts.push({
        reportId: repId,
        cost: repInput ? repInput.value : "$0.00",
      });
    });
    api.lp
      .processCases({
        folderCode,
        folderName: currentCase.folderName,
        comment: currentCase.comment,
        reportCosts,
      })
      .then(() => {
        this.props.updateCase(currentCase);
        this.removeUserCaseCharges();
        this.props.onLoadComplete();
      })
      .catch((err) => console.log("Unable to process case request - ", err));
  };

  render() {
	const {errorNode} = this.state;
	if(errorNode !== undefined) return errorNode;
    const rows = [];
    const reports = this.state.reports;
    if (reports.length > 0) {
      let prevReportTypeDescription;
      const combinedCosts = this.state.combinedCosts;
      _.forEach(reports, (report, index) => {
        if (
          prevReportTypeDescription === undefined ||
          report.ReportTypeDescription[0] !== prevReportTypeDescription
        ) {
          rows.push(
            <Table.Row
              key={`case_rep_${index}_header`}
              className="report-sub-section-header"
            >
              <Table.Cell colSpan={6}>
                {report.ReportTypeDescription[0].toUpperCase()}
              </Table.Cell>
            </Table.Row>
          );
          prevReportTypeDescription = report.ReportTypeDescription[0];
        }
        rows.push(
          <Table.Row key={`case_rep_${index}`}>
            <Table.Cell />
            <Table.Cell>{`${report.ReportLabel[0]} ${
              !report.ReportLabel[0].includes("Report") &&
              !report.ReportLabel[0].includes("Search")
                ? "Search"
                : ""
            } ${
              report.NumberAtCost[0] === 0
                ? `( first ${report.NumberAtCost[0]} )`
                : ""
            }`}</Table.Cell>
            <Table.Cell>{report.SearchResultCost[0]}</Table.Cell>
            <Table.Cell>{report.SearchNoResultCost[0]}</Table.Cell>
            <Table.Cell>{report.SearchResultCost[0]}</Table.Cell>
            <Table.Cell>
              <Input
                id={`rep_val_${report.ReportID[0]}`}
                value={combinedCosts[report.ReportID[0]]}
                onChange={(e, data) =>
                  this.reportCostChanged(e, data, report.ReportID[0])
                }
              />
            </Table.Cell>
          </Table.Row>
        );
      });
    }
    return (
      <div>
        <br />

        <Table>
          <Table.Body>
            <Table.Row className="report-section-header">
              <Table.HeaderCell width={2}>Type</Table.HeaderCell>
              <Table.HeaderCell width={4}>Service</Table.HeaderCell>
              <Table.HeaderCell width={3}>
                Service Charge - Hit
              </Table.HeaderCell>
              <Table.HeaderCell width={3}>
                Service Charge - No Hit
              </Table.HeaderCell>
              <Table.HeaderCell width={2}>My Charge</Table.HeaderCell>
              <Table.HeaderCell width={2}>This Case</Table.HeaderCell>
            </Table.Row>
            {rows}
          </Table.Body>
        </Table>
        <Table className={"table-no-border"}>
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan={6}>
                <div className={"float-right"}>
                  <Button primary onClick={() => this.submit()}>
                    {this.props.buttonText}
                  </Button>
                  <Button
                    className={"no-background-color"}
                    onClick={() => this.props.cancelEdit()}
                  >
                    Cancel
                  </Button>
                </div>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}
export default connect(mapStateToProps, {
  loadUi,
  expireSession,
  removeUserCaseCharges,
})(EditCaseDetails);



// WEBPACK FOOTER //
// ./src/components/myaccount/EditCaseDetails.js